const DIALOG_WIDTHS = {
    _332: '20.75rem',
    _568: '35.5rem',
};
export default DIALOG_WIDTHS;
